import { useEffect, useState } from "react";
import { TiPencil } from "react-icons/ti";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import BankDetails from "./components/BankDetails";
import AddInstaller from "./components/AddInstaller";
import { isValidObject, parseByDateRange } from "../../utils";
import { getInstallers } from "../../actions/installer";
import { dropdownDefaultList, headerColumn } from "../../constants";
import { useApiRequest } from "../../hooks/useApiRequest";
import DateRangeSelector from "../../Common/DateRangeElement";
import SearchableDropdown from "../../Common/SearchDropdown";

const InstallerPage = () => {
    const [state, setState] = useState({
        showBankDetails: false,
        addInstaller: false,
        loading: false,
        status: "",
        search: "",
        installers: [],
        list: [],
        installerData: {},
        current: 1,
        total: 1
    });
    const { showBankDetails, addInstaller, current, search, total, loading, installers, installerData, status, list } = state;
    const { request: submitRequest } = useApiRequest();

    const getInstData = (status) => {
        setState(prev => ({...prev, loading: true }))
        getInstallers(status).then(response => {
            const { data } = response.data;
            if(isValidObject(data)){
                setState(prev => ({...prev, installers: data?.installers ?? [], total: data?.total ?? 1 }));
            }
        }).catch(ex => {}).finally(() => setState(prev => ({...prev, loading: false })))
    }

    const changeInstallerStatus = (id, status) => {
        submitRequest({
            url: `/api/v1/installers/${id}/status`,
            method: "PUT",
            body: {
                status: String(status).toLowerCase()
            },
            onSuccess: () => {
                setState(prev => ({...prev, status: null }))
                getInstData()
            }
        })
    }

    const filterByData = (range) => {
        if(isValidObject(range)){
            const data = parseByDateRange(installers, range)
            setState(prev => ({...prev, list: data }))
        }
    }

    useEffect(() =>{
        getInstData(status);
    }, [status])

    useEffect(() => {
        const items = search ? installers?.filter((installer) => {
          const searchLower = search.toLowerCase();
          return (installer.name?.toLowerCase().includes(searchLower) ||
          installer.mobileNo?.toLowerCase().includes(searchLower))
        }) : installers;
        setState(prev => ({...prev, list: items }))
      }, [search, installers]);

    return <div className="installer-container">
        <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({...prev, search: e.target.value }))} />
        <TableComponent title={"Installer Details"} col={4} headers={headerColumn.installers} data={list} tableLoading={loading} current={current} total={total} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.name ?? "-"}</td>
            <td>{tdData?.mobileNo ?? "-"}</td>
            <td>{tdData?.salaryType ?? "-"}</td>
            <td>
            <div className={`action-status ${tdData?.status ?? ""} d-flex justify-content-center align-items-center px-3`}>
                <SearchableDropdown
                placeholder={"Status"}
                value={tdData?.status ?? "Active"}
                error={false}
                options={dropdownDefaultList.installerStatus}
                onSelect={(value) => changeInstallerStatus(tdData?.installerId, value?.name)}
            />
            </div>
            </td>
            <td>
                <div className="action d-flex justify-content-center align-items-center px-3">
                    {/* <ButtonElement text={<MdOutlineRemoveRedEye size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => { }} variant="btn-outline-preview" loading={false} /> */}
                    <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => setState(prev => ({ ...prev, addInstaller: true, installerData: tdData }))}  variant="btn-outline-edit" loading={false} />
                </div>
            </td>
        </tr>} FilterComponent={
                <div className="installer-filters d-flex justify-content-end">
                <SearchableDropdown
                placeholder={"Status"}
                value={status}
                error={false}
                options={dropdownDefaultList.installerStatus}
                onSelect={(value) => setState(prev => ({ ...prev, status: value?.name }))}
            />
            <DateRangeSelector updateRange={filterByData} />
            <ButtonElement text={"Add Installer"} cssClass="small-radius mb-1" onClick={() => setState(prev => ({ ...prev, addInstaller: true, installerData: {} }))} variant="btn-black" loading={false} />
        </div>} />

        {showBankDetails ? <BankDetails show={showBankDetails} hideModal={() => setState(prev => ({ ...prev, showBankDetails: false }))} /> : null}
        {addInstaller ? <AddInstaller show={addInstaller} hideModal={() => setState(prev => ({ ...prev, addInstaller: false, installerData: {} }))} installerData={installerData} getInstData={getInstData}  /> : null}
    </div>
}

export default InstallerPage;